// extracted by mini-css-extract-plugin
export var body = "_nw-8";
export var button = "_nw-0";
export var closeButton = "_nw-5";
export var content = "_nw-3";
export var empty = "_nw-f";
export var grid = "_nw-c";
export var header = "_nw-4";
export var icon = "_nw-1";
export var option = "_nw-d";
export var optionSelected = "_nw-e";
export var overlay = "_nw-2";
export var searchIcon = "_nw-a";
export var searchInput = "_nw-b";
export var searchWrapper = "_nw-9";
export var title = "_nw-6";
export var visuallyHidden = "_nw-7";